module.exports = __webpack_public_path__ + "img/PCT02.2cee1df2.svg";